import axios from "axios";

const drivers = {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        async getRemittanceList(context, payload) {
            let response = await axios.get(`/get_remittance_list/${payload}`);
            if (response.status === 200) {
                return response;
            }
        },
        async getWayBillInfo(context, payload) {
            let response = await axios.get(`/get_waybill/${payload}`);
            if (response.status === 200) {
                return response;
            }
        },
        async getWayBillBalance(context, payload) {
            let response = await axios.get(`/get_waybill_balance/${payload}`);
            if (response.status === 200) {
                return response;
            }
        },
        async setActualTransfer(context, payload) {
            let response = await axios.post('/set_waybill_actual_date_time', {WayBillNumber: payload})
            if (response.status === 200) {
                return response;
            }
        },
        async setActualTransferForSaleExi(context, payload) {
            let response = await axios.post('/set_exi_actual_date_time',
                {Sale_Num: payload.Sale_Num, issueFinance: payload.issueFinance, wayBillNumber: payload.wayBillNumber})
            if (response.status === 200) {
                return response;
            }
        },
        async addPayFinanceDocument(context, payload) {
            let response = await axios.post('/add_pay_finance_document',payload)
            if (response.status === 200) {
                return response;
            }
        },
        async addDocumentFinanceDocument(context, payload) {
            let response = await axios.post('/add_document_finance_document',payload)
            if (response.status === 200) {
                return response;
            }
        },
        async setWayBillAttachmentFlag(context, payload){
            let response = await axios.get(`/set_waybill_attachment_flag/${payload.wayBillNumber}/${payload.flag}`);
            if (response.status === 200) {
                return response;
            }
        },
    },
    getters: {}
}

export default drivers;
